import { render, staticRenderFns } from "./FinalizingWorkflowDialog.vue?vue&type=template&id=130b2bda&scoped=true&"
import script from "./FinalizingWorkflowDialog.vue?vue&type=script&lang=ts&"
export * from "./FinalizingWorkflowDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FinalizingWorkflowDialog.vue?vue&type=style&index=0&id=130b2bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130b2bda",
  null
  
)

export default component.exports